import type { TranslatedString } from './shared';

export enum NotificationChannelTypes {
  EMAIL = 'EMAIL',
  IN_APP = 'IN_APP',
  PUSH = 'PUSH',
  WEBHOOK = 'WEBHOOK',
}

export type NotificationChannel = {
  allowEditByClient?: boolean;
  setDefaultState?: boolean;
  type: NotificationChannelTypes;
  value: boolean;
};

export type NotificationGroup = {
  id: string;
  name: TranslatedString;
  description?: TranslatedString;
  notificationChannels: NotificationChannel[];
};
